export class StrategyTable {
  public static content = {
    "WPBet_QQPBet": {
      "WPBet": {
        "1": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "2": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "3": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "4": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "5": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ],
        "6": [
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9
        ]
      },
      "QQPBet": {
        "horse_selected_banker_sel": {
          "1": [
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            8
          ],
          "2": [
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            8
          ],
          "3": [
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            8
          ],
          "4": [
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            8
          ],
          "5": [
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            8
          ]
        },
        "horse_selected_cross_sel": {
          "2": [
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            8
          ],
          "3": [
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            8
          ],
          "4": [
            0,
            1,
            2,
            3,
            4,
            7
          ],
          "5": [
            0,
            1,
            2,
            3,
            5,
            8
          ],
          "6": [
            0,
            1,
            2,
            3
          ]
        }
      }
    },
    "WPBet": {
      "1": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "2": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "3": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "4": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "5": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ],
      "6": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9
      ]
    },
    "QQPBet": {
      "horse_selected_banker_sel": {
        "1": [
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8
        ],
        "2": [
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8
        ],
        "3": [
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8
        ],
        "4": [
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8
        ],
        "5": [
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8
        ]
      },
      "horse_selected_cross_sel": {
        "2": [
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8
        ],
        "3": [
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8
        ],
        "4": [
          0,
          1,
          2,
          3,
          4,
          5,
          7,
          8
        ],
        "5": [
          0,
          1,
          2,
          3,
          5,
          8
        ],
        "6": [
          0,
          1,
          2,
          3
        ]
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/horse/horse-bet-data/StrategyTable.ts